import React, { useState, useEffect, useRef, useContext } from "react";
import PdtHeader from "./pdtheader";
import Form from 'react-bootstrap/Form';
import AmbSSTCU from "./ambsstcu";
import FooterPrice from "./footerprice";
import axios from "axios";
import ModelSelectCard from "./modelselectcard";
import "./css/common.css";
import Loader from 'react-loader-spinner'
import { Alert } from "react-bootstrap";
import "./css/selectioncard.css";
import {StateAmbContext} from '../../stateContext';
import { useTranslation } from 'react-i18next';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { fetchMitigationData } from "./mitigationzone";
import A2LToggle from "./a2lToggle";

export default function BuildCUNew(props) {
    const { settings } = useContext(StateAmbContext);

    const { t, i18n } = useTranslation();
    const [hideBuilder, setBuilder] = useState(false);
    const [didRender, setRender] = useState(false);
    const [state, setState] = useState({ selectionmode: "direct", loader: true, noModels: false, AlertMessage:  t('alert_msg.cu_no_single') } )
    var { models, ...affectingProps } = props.activevalue;
    
    const changeView = (view) => {
        setBuilder(view);
    }
    const dataProps = useRef();
    const SelectedModel = props.activevalue.selected_model;
    const controllerRef = useRef();
    const [selectedRds, setSelectedRds] = useState("")
    const [error, setError] = useState('');

    const [area, setArea] = useState('');
    const [height, setHeight] = useState('');  
    const [getModelNumber, setGetModelNumber] = useState([]);
    const [mitigationzonedata, setMitigationZoneData] = useState([])
    const [prevarea, setPrevArea] = useState('')
    const [renderAreaAndHeightInputs, setRenderAreaAndHeightInputs] = useState(false)
    const [selectedValue, setSelectedValue] = useState(props.activevalue.ref);  
    const [a2lisOn, setA2lsOn] = useState(false);

    const a2lToggleHandler = () => {
        setA2lsOn((prevState) => {
          const newValue = !prevState;
          const isRefValid = ['R-455A', 'R-454A', 'R-454C'].includes(props.activevalue.ref);
          if (isRefValid && newValue) {
            localStorage.setItem('a2lToggle', JSON.stringify(true));
          } else {
            localStorage.setItem('a2lToggle', JSON.stringify(newValue));
          }
          return newValue;
        });
    };

    useEffect(() => {
        const storedA2L = localStorage.getItem('a2lToggle');
        if (storedA2L !== null) {
          setA2lsOn(JSON.parse(storedA2L));
        }
    }, []);

    const handleDropdownChange = async (e) => {
        const selectedValue = e.target.value;
        setSelectedValue(selectedValue);
        await props.update("ref", selectedValue);

        if (['R-455A', 'R-454A', 'R-454C'].includes(selectedValue)) {
            // localStorage.setItem('a2lToggle', true);
            // setA2lsOn(true);
            const storedRds = localStorage.getItem('rds');
            if (storedRds) {
                setSelectedRds(storedRds);
            } else {
                setSelectedRds('Factory Installed');
                localStorage.setItem('rds', 'Factory Installed');
            }

            const storedArea = localStorage.getItem('area');
            setArea(storedArea || "");

            setError('');
            if (props.tool === "System") {
                await fetchMitigationData({
                    area: storedArea,
                    selectedValue,
                    height,
                    getModelNumber,
                    props,
                    setMitigationZoneData,
                    setPrevArea,
                    setState,
                    settings
                });
                setRenderAreaAndHeightInputs(true);
            }
        } else {
            setA2lsOn(false);
            localStorage.setItem('a2lToggle', false);
            localStorage.removeItem('rds');
            localStorage.removeItem('area');
        }
    };

        useEffect( async ()=>{
        if(SelectedModel){ 
            if(controllerRef.current){
                controllerRef.current.abort();
            } 
            const controller = new AbortController();
            controllerRef.current = controller;  
            var materialObj = {};
            var modelObj = props.activevalue.models.find(model=>{
                if (model.model === SelectedModel){
                    return model; 
                }
            });
            var hold_packages = modelObj.option_packages.filter(op=> op.code!=="A0000").map(op=>{
                return op.code
            });
            if(hold_packages.length === 0){return};
            materialObj[SelectedModel] = hold_packages;
            const params = {"accessTokenUrl":settings.service_url,'PriceURL':settings.service_url,materialModels:materialObj};
            const res = await fetch(settings.service_url_pricing,
            {
                method:"POST",
                body:JSON.stringify({'params':params}),
                signal: controllerRef.current?.signal
            }
            ).then(async(pricingres)=>{
                const data = await pricingres.json();
                await props.updateNewPrice("CU",data['results']);
                controllerRef.current = null;
            });
        }
        
    },[SelectedModel])

    useEffect(() => {
        let defaultModel = {
            "model": "Unavailable",
            "label": "",
            "btuh": 0,
            "price": 0,
            "awef": 0,
            "option_packages": [
                { "code": "A0000", "label": "Air Defrost Timer", "price": 0 },
                { "code": "A0200", "label": "Dummy Timer", "price": 0 },
                { "code": "A0300", "label": "Another Timer", "price": 0 },
                { "code": "A0400", "label": "Testing Timer", "price": 0 }

            ],
            "technical_data": [
                { "label": "Capacity", "value": 0 },
                { "label": "MCA", "value": 0 },
                { "label": "MOPD", "value": 0 }
            ]
        }
        let user_input = props.activevalue;
        let a2lLocal = ['R-455A', 'R-454A', 'R-454C'].includes(user_input.ref) ? true : JSON.parse(localStorage.getItem('a2lToggle'));
        let comparator_str = JSON.stringify({
            type: 'cu',
            awef_flag: user_input.AWEF,
            brand: user_input.brand,
            temprature: user_input.temp,
            voltage: user_input.voltage,
            ref: user_input.ref,
            compressor_type: user_input.compressor,
            ambient: Number(user_input.amb_temp),
            sst: String(user_input.sst),
            btuh: Number(user_input.btuh),
            count: Number(user_input.count),
            unit_style: user_input.unit_style,
            a2l_flag: ['R-455A', 'R-454A', 'R-454C'].includes(user_input.ref) 
            ? true : (localStorage.getItem('a2lToggle') === null || localStorage.getItem('a2lToggle') === undefined ? false : JSON.parse(localStorage.getItem('a2lToggle'))),
        });
        dataProps.current = comparator_str;
        setState({...state, loader: true })
        axios.get(settings.marketing_service_url_1+`?type=cu&awef_flag=${user_input.AWEF}&ambient=${user_input.amb_temp}&brand=${user_input.brand}&Application=${user_input.temp}&voltage=${user_input.voltage}&ref=${user_input.ref}&compressor_type=${user_input.compressor}&sst=${user_input.sst}&btuh=${user_input.btuh}&count=${user_input.count}&selected_option=${user_input.selected_option}&unit_style=${user_input.unit_style}&a2l_flag=${a2lLocal}`)
            .then(async(response) => {
                if (true){// Condition to handle quick changes in user input so that only the lates response is updated
                let models_arr = [];
                let no_recom_model = false;
                if (!(response.data.lower === null || response.data.lower.model === undefined)) {
                    let lower = response.data.lower;
                    lower['key'] = "cu_lower";
                    models_arr.push({ ...defaultModel, ...lower })
                }
                if (!(response.data.recom === null || response.data.recom.model === undefined || response.data.recom.model === null)) {
                    let recom = response.data.recom;
                    recom['label'] = "RECOMMENDED"
                    recom['key'] = "cu_recom"
                    models_arr.push({ ...defaultModel, ...recom })
                }
                else {
                    no_recom_model = true;
                }
                if (!(response.data.upper === null || response.data.upper.model === undefined)) {
                    let upper = response.data.upper;
                    upper['key'] = "cu_upper"
                    models_arr.push({ ...defaultModel, ...upper })
                }

                if (models_arr.length === 0) {
                    props.update("models", [defaultModel, defaultModel, defaultModel])
                    setState({ noModels: true, loader: false, AlertMessage: t('alert_msg.unable_find_model') })
                    if(props.tool==="System"){
                        props.setCUModels(true);
                    }
                }
                else if (no_recom_model) {
                    props.update("models", models_arr);
                    if(props.tool==="System"){
                        props.setCUModels(true);
                    }
                    setState({ noModels: true, loader: false, AlertMessage:(settings.is_hub? t('alert_msg.cap_out_range_hub'):t('alert_msg.cap_out_range') ) })
                }
                else {
                    if(props.tool==="System"){
                        props.setCUModels(false);
                    }
                    props.update("models", models_arr);
                    setState({noModels: false, loader: false });
                    var materialObj = {};
                    for (var i=0;i<models_arr.length;i++){
                        // var holdPackages = ["A0000"]
                        // var holdPackages = models_arr[i]['option_packages'].map(option_package=>{                            
                        //         return option_package.code;
                        // });
                        materialObj[models_arr[i].model] =["A0000"];
                    };
                    const params = {"accessTokenUrl":settings.service_url,'PriceURL':settings.service_url,materialModels:materialObj};
                    const res = await fetch(settings.service_url_pricing,
                    {
                        method:"POST",
                        body:JSON.stringify({'params':params})
                    }
                    ).then(async(pricingres)=>{
                        const data = await pricingres.json();
                        await props.updateNewPrice("CU",data['results']);
                    });
                    
                    }

                }
            })
            .catch(err => {
                setState({ loader: false, noModels: true, AlertMessage: t('alert_msg.technical_err') });
            })

    }, [props.activevalue.unit_style, props.activevalue.amb_temp, props.activevalue.sst, props.activevalue.btuh, props.activevalue.AWEF, props.activevalue.brand, props.activevalue.count, props.activevalue.temp, props.activevalue.voltage, props.activevalue.ref, props.activevalue.unit_style, props.activevalue.compressor,a2lisOn]);

    let modelList = (props.activevalue.models.map(model => {
        return (
            <ModelSelectCard unit={"cu"} selected_option={props.activevalue.selected_option} onClick={() => { props.update("selected_model", model.model) }} active={(model.model == props.activevalue.selected_model) ? "active" : ""} key={model.key}  {...model} a2lselectCU={selectedValue} />
        )
    }));
    let boxarea = (state.loader ? <div className="loader" ><Loader
        type="Puff"
        color="#2D6FB7"
        height={100}
        width={100}
        visible={state.loader}
    // timeout={3000} //3 secs

    /></div> : modelList)
    return (
        <>
            {/* {props.tool !== "System" ? <Header /> : <></>} */}
            {props.tool !== "System" ? <><PdtHeader tool={props.tool} unit={"Condensing Unit"} />
                <AmbSSTCU boxloaded={props.boxloaded} onBuilder={changeView} tool={props.tool} navigate={props.navigate} activevalue={props.activevalue} update={props.update} /></> : <></>}
                <div className="custom_container m-auto">
                        <div className="card-deck card-main card_gr mbtm20">
                            <div className="card card justify-content-center">
                                <div className="disclamer" >{(settings.is_hub?t('common.pdt_disclaimer_hub'):t('common.pdt_disclaimer'))}</div>
                            </div>
                        </div>
                    </div>


            <div className={props.tool === "System" ? "row cu_area" : "row"}>
                <div className="custom_container ">
                    {/* <div hidden={hideBuilder} className="card-deck card-main card_gr mbtm20 dropm"> */}
                    <div className="card-deck card-main card_gr mbtm20 dropm media_width">
                        <div className="card card_gr">
                            <div>
                                <div className="card-body">
                                    <h4 className="card-title type_title"  >{t('unit_names.condensing_unit')}</h4>
                                    <div className="dropdown show boldst ">
                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="awef">
                                                    <Form.Label>{t('build_Ques.awef')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.AWEF}
                                                        onChange={(e) => { props.update("AWEF", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Yes">{t('common.Yes')}</option>
                                                        <option value="no">{t('common.No')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="brand">
                                                    <Form.Label>{t('build_Ques.brand')}</Form.Label>
                                                    <Form.Control
                                                        disabled={true}
                                                        value={props.activevalue.brand}
                                                        onChange={(e) => { props.update("brand", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="bohn">{t('brand.Bohn')}</option>
                                                        <option value="chandler">{t('brand.Chandler')}</option>
                                                        <option value="climate_control">{t('brand.Climate Control')}</option>
                                                        <option value="larkin">{t('brand.Larkin')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="count">
                                                    <Form.Label>{t('build_Ques.cu_count')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.count}
                                                        onChange={(e) => { props.update("count", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="1" >{t('common.numericals.1')}</option>
                                                        <option value="2" >{t('common.numericals.2')}</option>
                                                        <option value="3" >{t('common.numericals.3')}</option>
                                                        <option value="4" >{t('common.numericals.4')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="temp">
                                                    <Form.Label>{t('build_Ques.app_temp')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.temp}
                                                        onChange={(e) => { props.update("temp", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Medium Temp (Cooler)">{t('app_temp.med')}</option>
                                                        <option value="Low Temp (Freezer)">{t('app_temp.low')}</option>

                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="voltage">
                                                    <Form.Label>{t('build_Ques.voltage')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.voltage}
                                                        onChange={(e) => { props.update("voltage", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="208-230/1/60" >{t('voltages.208-230/1/60')}</option>
                                                        <option value="208-230/3/60" >{t('voltages.208-230/3/60')}</option>
                                                        <option value="208-230/3/50" >{t('voltages.208-230/3/50')}</option>
                                                        <option value="460/3/60" >{t('voltages.460/3/60')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="ref">
                                                    <Form.Label>{t('build_Ques.ref_type')}
                                                    <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip id="tooltip-a2l">A2L is Available now</Tooltip>}
                                                        >
                                                            <FaInfoCircle style={{ marginLeft: '8px', cursor: 'pointer', color: '#2d6fb7' }} />
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.ref}
                                                        onChange={handleDropdownChange}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="R-404A">{t('refs.R-404A')}</option>
                                                        <option value="R-407A">{t('refs.R-407A')}</option>
                                                        <option value="R-407C">{t('refs.R-407C')}</option>
                                                        <option value="R-407F">{t('refs.R-407F')}</option>
                                                        <option value="R-448A" selected>{t('refs.R-448A')}</option>
                                                        <option value="R-449A">{t('refs.R-449A')}</option>
                                                        <option value="R-507A">{t('refs.R-507A')}</option>
                                                        <option value="R-455A">{t('refs.R-455A')}</option>
                                                        <option value="R-454A">{t('refs.R-454A')}</option>
                                                        <option value="R-454C">{t('refs.R-454C')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" >
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="compressor">
                                                    <Form.Label>{t('build_Ques.compressor')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.compressor}
                                                        onChange={(e) => { props.update("compressor", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Scroll" >{t('compressors.Scroll')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            <div className="col-sm-6" >
                                                <Form.Group controlId="amptemp">
                                                    <Form.Label>{t('build_Ques.app_location')}</Form.Label>
                                                    <Form.Control
                                                        value={props.activevalue.unit_style}
                                                        onChange={(e) => { props.update("unit_style", e.target.value) }}
                                                        style={{ maxWidth: "100%" }} as="select">
                                                        <option value="Outdoor">{t('app_locations.Outdoor')}</option>
                                                        <option value="Indoor">{t('app_locations.Indoor')}</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                            {!["R-455A", "R-454A", "R-454C"].includes(props.activevalue.ref) && <div className="col-sm-6" >
                                                <A2LToggle a2lValue={a2lisOn} onToggle={a2lToggleHandler} />
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div style={{ backgroundColor: "#E6E7E8" }} className={props.tool === "System" ? "card cu_area_models mtmd10" : "card memargin mtmd10"}>
                            <div>
                                <div className="card-body ">
                                    <h4 className="card-title type_title">{t('model_select.cu_title')}</h4>
                                    <div className="dropdown show boldst ">
                                        {state.noModels ? <Alert variant="danger" dismissible>
                                            <Alert.Heading>{t('common.sorry')}</Alert.Heading>
                                            <p>
                                                {state.AlertMessage}
                                            </p>
                                        </Alert> : <>{boxarea}
                                            <div className="pt4">{t('common.preselect_opt')}</div>
                                        </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div >
                {props.tool === "System" ? <></> : <FooterPrice match={props.match} noModels={state.noModels} tool={props.tool} navigate={props.navigate} />}
            </div>
        </>
    )
}